export interface ParsedApiError {
  code: string | null;
  message: string;
}

interface ErrorDetail {
  code?: string;
  message?: string;
}

interface ErrorEnvelope {
  detail?: string | {
    message?: string;
    error?: ErrorDetail;
  };
  error?: ErrorDetail;
  message?: string;
}

export function parseApiErrorEnvelope(
  parsed: unknown,
  status: number,
): ParsedApiError {
  const envelope = parsed as ErrorEnvelope | null;
  const nestedDetail =
    envelope?.detail && typeof envelope.detail === "object"
      ? envelope.detail
      : null;
  const error = envelope?.error ?? nestedDetail?.error;

  return {
    code: error?.code ?? null,
    message:
      error?.message ??
      (typeof envelope?.detail === "string" ? envelope.detail : undefined) ??
      nestedDetail?.message ??
      envelope?.message ??
      `Request failed with status ${status}`,
  };
}
